import React from "react";
import GBETClientEventHelper from "../gbetclientevents";
import PDPSStore from "../../flux/PDPSStore.ts";

class LoginPanelV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            balances: {},
            userContext: {},
            balanceVisible: GBEglobal.settings.isBalanceVisible !== undefined ? GBEglobal.settings.isBalanceVisible.display : false,
            initPreferences: GBEglobal.preferences,
            showLoginWidget: false,
            showUsernameDropdown: false,
            showBalanceDropdown: false,
            showBalance: true
        };

        this.refreshBalances = this.refreshBalances.bind(this);
        this.setBalancesIfBlank = this.setBalancesIfBlank.bind(this);
        this.handleAccountsClick = this.handleAccountsClick.bind(this);
        this.toggleBalance = this.toggleBalance.bind(this);
        this.updateBalanceStorage = this.updateBalanceStorage.bind(this);

        this.recaptchaHandlerId;
        this.handleInputChange = this.handleInputChange.bind(this);

        this.showAccounts = this.showAccounts.bind(this);
        this.showBets = this.showBets.bind(this);
        this.showFreeBets = this.showFreeBets.bind(this);

        this.handleLogout = this.handleLogout.bind(this);
        this.toggleUsernameDropdown = this.toggleUsernameDropdown.bind(this);
        this.toggleBalanceDropdown = this.toggleBalanceDropdown.bind(this);
        this.onBlurUsernameDropdown = this.onBlurUsernameDropdown.bind(this);
        this.onBlurBalanceDropdown = this.onBlurBalanceDropdown.bind(this);
        this.showBets = this.showBets.bind(this);

    }

    componentDidMount() {
        const thisComponent = this;
        thisComponent.balanceDelegate = PDPSStore.addBalanceDelegate(function (balances) {
            thisComponent.setState({ balances });

        });
    }

    componentWillUnmount() {
        PDPSStore.removeBalanceDelegate(this.balanceDelegate);
    }

    loginUser(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-widget", eventAction: "click", eventLabel: value });
        var thisComponent = this;
        const reCaptchaGtvValue = GBEglobal.settings["system.reCAPTCHA.RequiredForEstablishSession"];
        const reCaptchaEnabled = ((typeof reCaptchaGtvValue === "string" && reCaptchaGtvValue.toLowerCase() === "true") || reCaptchaGtvValue === true);
        if (reCaptchaEnabled !== undefined && reCaptchaEnabled && configurationSettings.reCaptchaSiteKey) {
            if (thisComponent.recaptchaHandlerId === undefined) {
                thisComponent.recaptchaHandlerId = window.grecaptcha.render("irecaptcha", {
                    "sitekey": configurationSettings.reCaptchaSiteKey,
                    "size": "invisible",
                    "callback": function (token) {
                        thisComponent.props.onLoginRequest({
                            username: thisComponent.state.username,
                            password: thisComponent.state.password,
                            reCAPTCHAToken: token
                        });
                    },
                    "expired-callback": function () {
                        window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                    }
                });
                window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
            } else {
                window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
            }
        } else {
            thisComponent.props.onLoginRequest({
                username: thisComponent.state.username,
                password: thisComponent.state.password
            });
        }
    }

    toggleUsernameDropdown() {
        const thisComponent = this;

        thisComponent.setState({
            showUsernameDropdown: !thisComponent.state.showUsernameDropdown
        });

    }

    toggleBalanceDropdown() {
        const thisComponent = this;
        thisComponent.setState({
            showBalanceDropdown: !thisComponent.state.showBalanceDropdown
        });
    }

    showAccounts() {
        const thisComponent = this;
        thisComponent.props.onAccountClicked("account-summary");

    }

    showFreeBets() {
        const thisComponent = this;
        thisComponent.props.onAccountClicked("free-bets");

    }

    showDeposit() {
        const thisComponent = this;
        thisComponent.props.onAccountClicked("ftm/deposit");

    }

    onBlurUsernameDropdown() {
        const thisComponent = this;
        thisComponent.setState({
            showUsernameDropdown: false
        });
    }

    onBlurBalanceDropdown() {
        const thisComponent = this;
        thisComponent.setState({
            showBalanceDropdown: false
        });
    }

    showBets() {
        const thisComponent = this;
        thisComponent.props.onAccountClicked("current-bets");
    }

    toggleBalance(value) {
        const thisComponent = this;
        const isBalanceVisible = JSON.parse(window.localStorage.isBalanceVisible);
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: value });

        thisComponent.updateBalanceStorage(!isBalanceVisible);

        if (!isBalanceVisible) {
            this.refreshBalances({ showBalance: true });
        } else {
            thisComponent.setState({
                balanceVisible: !isBalanceVisible
            });
        }

    }


    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.userContext) !== JSON.stringify(prevProps.userContext)) {
            this.setState({
                userContext: this.props.userContext
            }, () => {
                const balanceVisible = GBEglobal.preferences.displayBalance !== undefined ? GBEglobal.preferences.displayBalance : this.state.balanceVisible;

                if (window.localStorage.isBalanceVisible === undefined && this.props.userContext) {
                    this.updateBalanceStorage(balanceVisible);
                }

                const localStorageBalance = window.localStorage.isBalanceVisible;
                if (localStorageBalance !== undefined && JSON.parse(localStorageBalance) && this.props.userContext) {
                    this.refreshBalances({ showBalance: true });
                }
            });
        }
    }

    getBalances() {
        return this.state.balances;
    }

    setBalancesIfBlank() {
        const thisComponent = this;

        if (GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {
            thisComponent.setState({ balances: PDPSStore.balance });
        } else {
            if (!thisComponent.state.balances || typeof thisComponent.state.balances.availableBalance === "undefined") {
                thisComponent.props.controller.getBalance({
                    callbackOnSuccess: function callbackOnSuccess(resp) {

                        thisComponent.setState({ balances: resp });
                    },
                    callbackOnException: function callbackOnException(resp) {
                        console.error(resp);
                    }
                });
            }
        }

    }

    refreshBalances(params) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: "refresh-balance" });
        const thisComponent = this;


        function afterBalances(resp) {
            const newState = {
                balances: resp
            };

            if (params !== undefined && params.showBalance) {
                thisComponent.updateBalanceStorage(true);
            }

            thisComponent.setState(newState);
            delete resp.balance;

            GBETClientEventHelper.fireDelegate("onBalanceUpdate", { mode: configurationSettings.mode, punter: window.getPunterDetails(), balance: resp });

        }

        if (GBEglobal.settings.pushPDPS?.enableSubscribeBalance) {
            window.setTimeout(function () {
                afterBalances(PDPSStore.balance);
            }, 1000);
        } else {
            if (window.localStorage.isBalanceVisible || params !== undefined && params.showBalance) {
                thisComponent.props.controller.getBalance({
                    callbackOnSuccess: afterBalances,
                    callbackOnException: function callbackOnException(resp) {
                        console.error(resp);
                    }
                });
            }
        }


    }

    handleLogout(value) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: value });
        this.props.onLogoutRequest();
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleAccountsClick(page) {
        GBEglobal.logger.log({ hitType: "event", eventCategory: "login-panel", eventAction: "click", eventLabel: page });
        this.props.onAccountClicked(page);
    }

    updateBalanceStorage(isBalanceVisible) {
        window.localStorage.setItem("isBalanceVisible", isBalanceVisible);
    }

    render() {
        const cSymbol = GBEUtils.getCurrencySymbol(GBEglobal.currency);
        const isBalanceVisible = window.localStorage.isBalanceVisible ? JSON.parse(window.localStorage.isBalanceVisible) : false;
        const isRegEnabled = GBEglobal.settings.accountSite !== undefined && GBEglobal.settings.accountSite.registration !== undefined ? GBEglobal.settings.accountSite.registration : true;
        if (window.canHaveSession !== true) {
            return (<div></div>);
        }
        const loginJoinMobileText = "Join Now";

        const usernameDropdownClassName = this.state.showUsernameDropdown ? "host-on" : "";
        const balanceDropdownClassName = this.state.showBalanceDropdown ? "host-on" : "";

        return (
            <div id="loginPanel" className="order-md-last">
                {this.props.userContext !== undefined &&
                    <div>
                        <div onBlur={this.onBlurUsernameDropdown} tabIndex="0" className={"host-dropdown host-account " + usernameDropdownClassName}>
                            <h3 onClick={this.toggleUsernameDropdown}>{this.props.userContext.partnerUsername}</h3>
                            <ul className="host-dropmenu">
                                <li><span className="menu-item" onClick={this.showAccounts}>My Account</span></li>
                                <li><span className="menu-item" href="" onClick={this.showBets}>My Bets</span></li>
                                <li><a onClick={this.handleLogout} className="menu-item host-logoutbutton" ><span style={{ "whiteSpace": "nowrap" }}>Logout</span></a></li>
                            </ul>
                        </div>

                        <div onBlur={this.onBlurBalanceDropdown} tabIndex="1" className={"host-dropdown host-balance " + balanceDropdownClassName}>
                            <h3 onClick={this.toggleBalanceDropdown}>Funds:
                                {isBalanceVisible &&
                                    <span id="displayBalance" dangerouslySetInnerHTML={{ __html: GBEUtils.formatDecimal(this.state.balances.availableBalance, 2, cSymbol, true) }}></span>
                                }
                            </h3>
                            <ul className="host-dropmenu">
                                <li><a onClick={this.showFreeBets} className="freeBets menu-item" >Free Bets <span id="freeBetEntitlementsCount"></span></a>
                                    <span id="freeBetEntitlements">
                                        <span id="freeBetEntitlementsAmount"></span>
                                    </span>
                                </li>
                                <li><span className="menu-item" onClick={this.toggleBalance}>{isBalanceVisible ? "Hide" : "Show"}</span> </li>
                            </ul>
                        </div>
                        {this.state.balances.availableBalance !== undefined && isBalanceVisible &&
                            <a href="" id="btnRefresh" className=" ml-1" onClick={(e) => {
                                e.preventDefault();
                                this.refreshBalances(e);
                            }
                            }></a>
                        }
                        {!this.props.userContext.isASubPunter &&
                            <input type="button" id="btnDeposit2" onClick={this.handleAccountsClick.bind(this, "ftm/deposit")} value="Deposit" />
                        }
                    </div>
                }

                {this.props.userContext === undefined &&
                    <div>
                        <form name="loginForm" id="loginForm" className="row" onSubmit={(e) => {
                            e.preventDefault();
                            this.loginUser("login");
                        }}>
                            <input id="username" name="username" type="text" className="form-control" placeholder="Email/Username" autoCapitalize="none" defaultValue={this.props.username}
                                required pattern=".{1,}" onChange={this.handleInputChange} />
                            <input id="password" name="password" type="password" className="form-control" placeholder="Password" autoComplete="off" autoCapitalize="none" defaultValue={this.props.password}
                                onChange={this.handleInputChange} />
                            <input type="submit" id="btnLogin2" value="Log In" />
                            {isRegEnabled &&
                                <input type="button" id="btnJoin2" onClick={this.handleAccountsClick.bind(this, "joinnow")} value={loginJoinMobileText} />
                            }
                        </form>
                        <div className="forgotUsernamePassword" style={{ "textAlign": "right" }}>
                            Forgot your <span onClick={this.handleAccountsClick.bind(this, "forgottenUsername")} style={{ "cursor": "pointer" }}>username</span> / <span onClick={this.handleAccountsClick.bind(this, "forgottenPassword")} style={{ "cursor": "pointer" }}>password</span> ?
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export { LoginPanelV2 };